<template>
  <div class="DetailImages">
    <div v-for="img in images" class="imgs">
      <my_image :src="img" :width="'17vw'" class="img"></my_image>
    </div>
  </div>
</template>

<script>
 import MyImage from '@/components/Image.vue'
export default {
  name: 'DetailImages',
   props: ['images'],
   components: {
     my_image: MyImage
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .DetailImages{
   display: flex;
   flex-wrap: wrap;
   width: 80vw;
   height: 30vw;
   align-items: center;
   align-content: space-between;
   justify-content: space-around;
 }
 .imgs{
   width: 22vw;
   height: 12.4vw;
   background-image: url(~@/assets/image/frontpage/bg-detailimg.png);
   background-size: 22vw;
   position: relative;
   display: flex;
   align-items: center;
   justify-content:flex-end;
 }

 .img{
   /* position: absolute;
      left: 3.85vw;
      top: -0.52vw; */
 }
</style>
